(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["vm-reviews"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('vm-reviews')) {
    customElements.define('vm-reviews', class extends HTMLElement {
      connectedCallback() {
        this.items = Array.from(this.querySelectorAll('[data-vmr-widget]')).map((wrap) => {
          const box = wrap.querySelector('.trustpilot-widget');
          return { wrap, box, frame: null, base: box ? parseInt(box.getAttribute('data-style-height'), 10) || 140 : 140 };
        }).filter((item) => item.box);
        if (!this.items.length) return;

        if ('ResizeObserver' in window) this.ro = new ResizeObserver(() => this.items.forEach((item) => this.fit(item)));
        this.mos = this.items.map((item) => {
          const mo = new MutationObserver(() => this.watch(item));
          mo.observe(item.box, { childList: true, subtree: true, attributes: true, attributeFilter: ['style', 'height'] });
          this.watch(item);
          return mo;
        });

        if (window.Shopify && Shopify.designMode) {
          this.whenTrustpilot((tp) => this.items.forEach((item) => tp.loadFromElement(item.box, true)));
        }
      }

      disconnectedCallback() {
        if (this.ro) this.ro.disconnect();
        if (this.mos) this.mos.forEach((mo) => mo.disconnect());
      }

      watch(item) {
        const frame = item.box.querySelector('iframe');
        if (frame && frame !== item.frame) {
          if (this.ro && item.frame) this.ro.unobserve(item.frame);
          item.frame = frame;
          if (this.ro) this.ro.observe(frame);
        }
        this.fit(item);
      }

      fit(item) {
        const h = item.frame ? Math.ceil(item.frame.getBoundingClientRect().height) : 0;
        const next = Math.max(item.base, h) + 'px';
        if (item.wrap.style.minHeight !== next) item.wrap.style.minHeight = next;
      }

      whenTrustpilot(cb) {
        if (window.Trustpilot) { cb(window.Trustpilot); return; }
        let tries = 0;
        const timer = setInterval(() => {
          if (window.Trustpilot) { clearInterval(timer); cb(window.Trustpilot); }
          else if (++tries > 50) { clearInterval(timer); }
        }, 200);
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
